/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SettingsInfoIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB8UlEQVR4nM1VPW8UQQxdiQIJEb7+AH8BUkZJv8rN2F6iOXsvRSryN1JEkVITJX+FAoWvGipASh1BjyBFGiB6ex/MTXZu7y4UWHIz4/Xz+Nlvi+J/sBDCLRL9TGKXcC/2BWf/DIB55wGJ/Yk9hHB/qWSbzwaPvdh7L7o7PnNVfzUFYB48Gd8j1ou9w7dzJNdvoyS/ie2Eqr4R28cUwIt+GN2dNLHD868zQVBFmogWdda3WQASex5Vs7B71l/IMbNNJHq8/Av0RdFlzKrX+23njustIlqBO67Fi521xPVbk2Kme73BQyJ7mhLqxc5DCI/SbxCPu5R4TBzupvYEi5N7tuN6K9vOSkOebPsUk3uZDSRayQGU5fa9LOFiP24MAMMuoC0AK8vyNhaQxPaI9eXfoKHO5FokxU0tJrnZ0OmnnuEu960XZSwXiV7Avdgb5tpnwZr1bxlTqjSgDVOxYocz9uJgqUXzYvWk8inx0zUn9Xoyti597m6XVLiqv9oU0rQlOpd6nVk3kmJeLyx2IYS7TSzbz05tikcVBqmF5E6Ei+0IvY+Jd87daQNob1ECMAYZvWSiigQJSX40mJY4WUR8LN2nxRK/zL3hWe27OKDKenMBYE+gV57tuxd7FVV7kO0/6/5cybsMo4hpAScNL6ynceVXA9hN44vQhx4AAAAASUVORK5CYII=)
 */
export const SettingsInfoIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M10.56 1.1c-.46.05-.7.53-.64.98.18 1.16-.19 2.2-.98 2.53-.8.33-1.79-.15-2.49-1.1-.27-.36-.78-.52-1.14-.24-.77.59-1.45 1.27-2.04 2.04-.28.36-.12.87.24 1.14.96.7 1.43 1.7 1.1 2.49-.33.8-1.37 1.16-2.53.98-.45-.07-.93.18-.99.64a11.1 11.1 0 0 0 0 2.88c.06.46.54.7.99.64 1.16-.18 2.2.19 2.53.98.33.8-.14 1.79-1.1 2.49-.36.27-.52.78-.24 1.14.59.77 1.27 1.45 2.04 2.04.36.28.87.12 1.14-.24.7-.95 1.7-1.43 2.49-1.1.8.33 1.16 1.37.98 2.53-.07.45.18.93.64.99a11.1 11.1 0 0 0 1.82.08c.38 0 .58-.43.4-.77a6.97 6.97 0 0 1-.35-5.63c.1-.28-.14-.59-.43-.59a4 4 0 1 1 4-4c0 .3.31.53.59.43a6.99 6.99 0 0 1 5.63.35c.34.18.76-.02.77-.4a11.39 11.39 0 0 0-.08-1.82c-.06-.46-.54-.7-.99-.64-1.16.18-2.2-.19-2.53-.98-.33-.8.14-1.79 1.1-2.49.36-.27.52-.78.24-1.14a11.07 11.07 0 0 0-2.04-2.04c-.36-.28-.87-.12-1.14.24-.7.96-1.7 1.43-2.49 1.1-.8-.33-1.16-1.37-.98-2.53.07-.45-.18-.93-.64-.99a11.1 11.1 0 0 0-2.88 0Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M19 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm1-4a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0v-1Zm0-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
